var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNordiq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 60,
    viewBox: "0 0 46 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_196)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_347_196",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.233 0H0V59.8596H45.233V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_347_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8978 8.66145C27.2105 9.02847 27.8009 8.92634 27.9733 8.47954L30.935 0.867825C31.0978 0.44974 30.7882 0.00292969 30.3414 0.00292969H20.8881C20.3456 0.00292969 20.052 0.638038 20.4031 1.05293L26.8978 8.66464V8.66145Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.487 0H39.4178C39.1593 0 38.9295 0.156383 38.8306 0.395745C37.0657 4.7266 33.0316 13.3021 32.1444 15.1787C32.0391 15.4053 32.0742 15.6702 32.237 15.8617L41.8082 27.0862C42.4497 27.8362 43.1902 28.2734 44.0072 28.3915L44.1253 28.4043V0.635106C44.1253 0.284043 43.8412 0 43.4901 0H43.487Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2421 32.0426L9.0986 0.223404C8.98052 0.0797872 8.8018 0 8.61988 0H1.34008C0.797525 0 0.503907 0.635106 0.854971 1.04681L37.1964 43.8989C37.3177 44.0426 37.4932 44.1223 37.6815 44.1223H43.4868C43.8379 44.1223 44.1251 43.8383 44.1251 43.484V35.2308L44.0038 35.25C41.0421 35.6936 38.4379 34.6181 36.2421 32.0426Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2032 24.0128C10.0021 23.7767 9.65745 23.7192 9.38936 23.882L0.306383 29.3809C0.114894 29.4958 0 29.7033 0 29.9235V43.4872C0 43.8383 0.284043 44.1224 0.635106 44.1224H9.59681C9.76915 44.1224 9.93191 44.0553 10.05 43.9309C12.6447 41.2692 17.3266 36.316 18.7053 34.8543C18.9287 34.6181 18.9383 34.2511 18.7277 34.0053L10.2032 24.0097V24.0128Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.96383 21.7818L5.16064 19.2382C5.49255 19.0371 5.56915 18.584 5.31702 18.2871L1.1234 13.2829C0.740425 12.8265 0 13.0978 0 13.6914V21.2393C0 21.734 0.542553 22.0403 0.96383 21.7818Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4149 40.3881C24.1628 40.0913 23.7032 40.0913 23.4479 40.3881L21.15 43.0754C20.7958 43.4871 21.0894 44.1254 21.632 44.1254H26.2181C26.7607 44.1254 27.0543 43.4903 26.7032 43.0786L24.4149 40.3913V40.3881Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19574 55.65L1.63723 49.8574H0V58.7681H1.63723V53.001L5.19574 58.7681H6.83298V49.8574H5.19574V55.65Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7332 49.8574H10.4172C9.5555 49.8574 8.87891 50.5117 8.87891 51.3287V57.2968C8.87891 58.1138 9.5555 58.7681 10.4172 58.7681H13.7332C14.5949 58.7681 15.2842 58.1138 15.2842 57.2968V51.3287C15.2842 50.5117 14.5917 49.8574 13.7332 49.8574ZM13.5927 56.9489C13.5927 57.15 13.4236 57.2968 13.2129 57.2968H10.9534C10.7427 57.2968 10.5736 57.15 10.5736 56.9489V51.6766C10.5736 51.4755 10.7427 51.3287 10.9534 51.3287H13.2129C13.4236 51.3287 13.5927 51.4755 13.5927 51.6766V56.9489Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8117 53.8564V51.3287C23.8117 50.5117 23.1192 49.8574 22.2606 49.8574H17.3362V58.7681H19.0309V55.3308H20.8085L22.5862 58.7681H24.45L22.6436 55.2893C23.3202 55.1298 23.8149 54.5521 23.8149 53.8564H23.8117ZM22.117 53.5085C22.117 53.7096 21.9479 53.8564 21.7372 53.8564H19.0277V51.3287H21.7372C21.9479 51.3287 22.117 51.4755 22.117 51.6766V53.5085Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5874 49.8574H26.0012V58.7681H30.5874C31.4491 58.7681 32.1385 58.1138 32.1385 57.2968V51.3287C32.1385 50.5117 31.4459 49.8574 30.5874 49.8574ZM30.447 56.9489C30.447 57.15 30.2778 57.2968 30.0672 57.2968H27.6959V51.3287H30.0672C30.2778 51.3287 30.447 51.4755 30.447 51.6766V56.9489Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7414 49.7617H34.1169V51.4755H35.7414V49.7617Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7414 52.4268H34.1169V58.7682H35.7414V52.4268Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1253 57.2968V51.3287C44.1253 50.5117 43.4327 49.8574 42.5742 49.8574H39.2583C38.3966 49.8574 37.72 50.5117 37.72 51.3287V57.2968C37.72 58.1138 38.3966 58.7681 39.2583 58.7681H42.5742C42.6923 58.7681 42.8072 58.7553 42.9189 58.7298L44.1668 59.8595L45.2359 58.7553L44.0678 57.6989C44.1061 57.5712 44.1285 57.4372 44.1285 57.2968H44.1253ZM42.4306 56.9489C42.4306 57.15 42.2615 57.2968 42.0508 57.2968H39.7912C39.5806 57.2968 39.4115 57.15 39.4115 56.9489V51.6766C39.4115 51.4755 39.5806 51.3287 39.7912 51.3287H42.0508C42.2615 51.3287 42.4306 51.4755 42.4306 51.6766V56.9489Z",
    fill: "#231F20"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.3191,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordiq);
export default __webpack_public_path__ + "static/media/nordiq.51eaa75320c26470caf97a80c38d5896.svg";
export { ForwardRef as ReactComponent };